import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase'; 
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { signInAnonymously } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import logo from '../assets/logo/1logo.png';
import '../Header.css';

function Header() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null); 
  const [isMobile, setIsMobile] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [fullName, setFullName] = useState('');
  const [isNewUser, setIsNewUser] = useState(false); 
  const [isLoginMode, setIsLoginMode] = useState(false); // പുതിയ ലോഗിൻ മോഡ് സ്റ്റേറ്റ്

  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const openModal = () => {
      setShowLoginModal(true);
    };

    window.addEventListener('openAuthModal', openModal);

    return () => {
      window.removeEventListener('openAuthModal', openModal);
    };
  }, []);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 9) {
      setPhoneNumber(value);
    }
  };

  const handleGetOtp = async (e) => {
    e.preventDefault();
    if (phoneNumber.length !== 9) {
      alert("Please enter a valid 9-digit mobile number");
      return;
    }

    try {
      const userDoc = await getDoc(doc(db, "users", phoneNumber));
      
      // ലോഗിൻ മോഡിൽ ആണെങ്കിൽ അക്കൗണ്ട് ഉണ്ടോ എന്ന് നോക്കുന്നു
      if (isLoginMode && !userDoc.exists()) {
        alert("Account not found. Please register.");
        setIsLoginMode(false); // അക്കൗണ്ട് ഇല്ലെങ്കിൽ രജിസ്റ്റർ മോഡിലേക്ക് മാറ്റുന്നു
        return;
      }

      if (userDoc.exists()) {
        setIsNewUser(false);
        setFullName(userDoc.data().fullName || '');
      } else {
        setIsNewUser(true); 
      }
      setIsOtpSent(true);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  const handleVerifyAndLogin = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join('');
    
    if (enteredOtp === "2255") { 
      setIsLoading(true); 
      try {
        // 1. Firebase Auth വഴി അനോണിമസായി ലോഗിൻ ചെയ്യുന്നു (Auth Session നിലനിർത്താൻ)
        const userCredential = await signInAnonymously(auth);
        const fbUser = userCredential.user;

        // 2. Firestore-ലേക്ക് ഡാറ്റ സേവ് ചെയ്യുന്നു
        await setDoc(doc(db, "users", phoneNumber), {
          fullName: fullName,
          phone: phoneNumber,
          lastLogin: new Date(),
          role: "customer",
          uid: fbUser.uid // Auth UID കൂടി ലിങ്ക് ചെയ്യുന്നു
        }, { merge: true });

        // 3. പേജ് റിഫ്രഷ് ആയാലും ഡാറ്റ കിട്ടാൻ localStorage-ൽ ബാക്കപ്പ് വെക്കുന്നു
        localStorage.setItem('userPhone', phoneNumber);

        handleModalClose();
        navigate('/booking');
      } catch (error) {
        console.error("Error saving user:", error);
        alert("Something went wrong. Please try again.");
      } finally {
        setIsLoading(false); 
      }
    } else {
      alert("Invalid OTP! Please use 2255");
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);

      // Remove all user login data
      localStorage.removeItem('userPhone');
      
      // അല്ലെങ്കിൽ
      // localStorage.clear();

      navigate('/');

      // Header state refresh ചെയ്യാൻ
      window.location.reload();

    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const handleModalClose = () => {
    setShowLoginModal(false);
    setIsOtpSent(false);
    setIsLoginMode(false); // മോഡൽ ക്ലോസ് ചെയ്യുമ്പോൾ ലോഗിൻ മോഡ് റീസെറ്റ് ചെയ്യുന്നു
    setPhoneNumber('');
    setOtp(['', '', '', '']);
    setFullName('');
  };

  return (
    <header className="main-header">
      <nav className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="MR WHITE Logo" />
          </Link>
        </div>

        <div className="nav-container">
          <ul className={isMobile ? "nav-links-mobile" : "nav-links"}>
            <li onClick={() => setIsMobile(false)}><Link to="/">Home</Link></li>
            <li onClick={() => setIsMobile(false)}><Link to="/about">About Us</Link></li>
            <li onClick={() => setIsMobile(false)}><Link to="/Services">Our Services & Pricing</Link></li>
            <li onClick={() => setIsMobile(false)}><Link to="/Howitworks">How it works</Link></li>
            <li onClick={() => setIsMobile(false)}><Link to="/Contact">Contact Us</Link></li>
            
            {/* 🎯 HIDDEN: Mobile Auth Controls */}
            <li className="nav-login-mobile" style={{ display: 'none' }}>
              {user ? (
                <div className="mobile-user-actions">
                  <button className="btn-login-gradient" onClick={() => { navigate('/profile'); setIsMobile(false); }}>Profile</button>
                  <button className="btn-logout-mobile" onClick={handleLogout}>Logout</button>
                </div>
              ) : (
                <button className="btn-login-gradient" onClick={() => { setShowLoginModal(true); setIsMobile(false); }}>Register</button>
              )}
            </li>
          </ul>

          <div className="header-actions">
            {/* 🎯 HIDDEN: Desktop Auth Controls */}
            <div style={{ display: 'none' }}>
              {user ? (
                <div className="user-logged-in-wrapper desktop-only">
                  <div className="profile-icon-container" onClick={() => navigate('/profile')}>
                    <div className="user-profile-circle">
                       <i className="fas fa-user"></i>
                    </div>
                  </div>
                  <button className="logout-icon-btn" onClick={handleLogout} title="Logout">
                    <i className="fas fa-sign-out-alt"></i>
                  </button>
                </div>
              ) : (
                <button className="btn-login-gradient desktop-only" onClick={() => setShowLoginModal(true)}>
                  <i className="fas fa-user-circle"></i> Register
                </button>
              )}
            </div>
            
            <button className="mobile-menu-icon" onClick={() => setIsMobile(!isMobile)}>
              <i className={isMobile ? "fas fa-times" : "fas fa-bars"}></i>
            </button>
          </div>
        </div>
      </nav>

      {showLoginModal && (
        <div className="auth-modal-overlay" onClick={handleModalClose}>
          <div className="auth-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={handleModalClose}>&times;</button>
            
            <div className="auth-modal-content">
              <div className="auth-modal-left">
                <img src={logo} alt="MR WHITE" />
                <p>Experience the best laundry & dry cleaning service in UAE.</p>
              </div>

              <div className="auth-modal-right">
                {!isOtpSent ? (
                  <div className="animation-fadeIn">
                    <h2>{isLoginMode ? "Welcome Back!" : "Join Mr White"}</h2>
                    <p className="subtitle">
                      {isLoginMode ? "Login to your account" : "Enter your details to get started"}
                    </p>
                    
                    <form className="auth-form" onSubmit={handleGetOtp}>
                      {!isLoginMode && (
                        <div className="form-group animation-slide-down">
                          <label>Full Name</label>
                          <div className="input-with-icon">
                            <i className="fas fa-user"></i>
                            <input 
                              type="text" 
                              placeholder="Enter your name" 
                              value={fullName} 
                              onChange={(e) => setFullName(e.target.value)} 
                              required 
                            />
                          </div>
                        </div>
                      )}

                      <div className="form-group">
                        <label>Phone Number</label>
                        <div className="phone-input-wrapper">
                          <span className="country-code">+971</span>
                          <input 
                            type="text" 
                            inputMode="numeric" 
                            placeholder="5x xxx xxxx" 
                            value={phoneNumber} 
                            onChange={handlePhoneChange} 
                            required 
                          />
                        </div>
                      </div>
                      
                      <button type="submit" className="btn-get-otp">
                        {isLoginMode ? "Login" : "Get OTP"}
                      </button>
                    </form>

                    <p className="auth-switch-text">
                      {isLoginMode ? "Don't have an account?" : "Already have an account?"}
                      <span className="auth-link-text ml-5" onClick={() => setIsLoginMode(!isLoginMode)}>
                        {isLoginMode ? "Register" : "Login"}
                      </span>
                    </p>
                  </div>
                ) : (
                  <div className="otp-section animation-fadeIn">
                    <h2>{isNewUser ? "Complete Registration" : "Verify OTP"}</h2>
                    <p className="subtitle">Sent to +971 {phoneNumber}</p>
                    <div className="otp-box-wrapper">
                      {otp.map((data, index) => (
                        <input
                          key={index}
                          type="text"
                          className="otp-individual-box"
                          maxLength="1"
                          value={data}
                          ref={inputRefs[index]}
                          onChange={(e) => {
                            if (isNaN(e.target.value)) return;
                            const newOtp = [...otp];
                            newOtp[index] = e.target.value.substring(e.target.value.length - 1);
                            setOtp(newOtp);
                            if (e.target.value && index < 3) inputRefs[index + 1].current.focus();
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Backspace' && !otp[index] && index > 0) inputRefs[index - 1].current.focus();
                          }}
                        />
                      ))}
                    </div>
                    <button 
                      className="btn-get-otp mt-20" 
                      onClick={handleVerifyAndLogin}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <span className="loader-spinner"></span>
                      ) : (
                        isNewUser ? "Register & Login" : "Verify & Login"
                      )}
                    </button>
                    <p className="resend-text">
                      Didn't receive code? <span className="auth-link-text ml-5" onClick={() => setIsOtpSent(false)}>Edit Details</span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;